/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Navaneeth Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "NavaneethSilikveri | Portfolio",
    type: "website",
    url: "http://navaneeth91.github.io/",
  },
};

//Home Page
const greeting = {
  title: " Navaneeth Siliveri",
  logo_name: "Navaneeth",
 
  subTitle:
    "A dedicated Computer Science student with strong skills in software development, data structures, and web technologies. Proficient in Java and experienced in building responsive web applications using modern tools.",
  resumeLink:
    "https://drive.google.com/file/d/1FtN91At89UDpno1ef2ECfRIaYMtrZCKv/view?usp=sharing",
  portfolio_repository: "https://github.com/navaneeth91/navaneethPortfolio",
  githubProfile: "https://github.com/navaneeth91",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/navaneeth91",
  // linkedin: "https://www.linkedin.com/in/navaneeth-siliveri-99b1392a9",
  // gmail: "navaneeth91@gmail.com",
  // gitlab: "https://gitlab.com/navaneeth91",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/navaneeth91",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/navaneeth-siliveri-99b1392a9/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://youtube.com/c/DevSense19",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:navaneethsiliveri02@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://x.com/navaneeth_02",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/Navaneeth04/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/_navaneeth__04/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Web Development & Programming",
      fileName: "SoftwareDevelopmentImg",
      skills: [
        "⚡ Building responsive web applications using React.js and modern JavaScript.",
        "⚡ Writing clean, modular code in Java, C++, C, and Python.",
        "⚡ Implementing data structures and algorithms to solve real-world problems efficiently.",
      ],
      softwareSkills: [
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#007396",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#00599C",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#00599C",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#F05032",
          },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "VS Code",
          fontAwesomeClassname: "simple-icons:visualstudiocode",
          style: {
            color: "#007ACC",
          },
        },
      ],
    },
    {
      title: "Full Stack & Databases",
      fileName: "FullStackImg",
      skills: [
        "⚡ Developing basic full stack applications using React and Node.js.",
        "⚡ Designing and querying relational databases (MySQL).",
        "⚡ Working with NoSQL databases like MongoDB for modern web apps.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:nodedotjs",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
      ],
    },
    {
      title: "Cloud & Dev Tools",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Hands-on experience with AWS EC2 for hosting and deployment.",
        "⚡ Understanding of cloud computing fundamentals and basic infrastructure management.",
        "⚡ Using modern developer tools for collaboration and version control.",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#F05032",
          },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#181717",
          },
        },
      ],
    },
    {
      title: "CS Fundamentals & Problem Solving",
      fileName: "DesignImg",
      skills: [
        "⚡ Strong foundation in Data Structures, Algorithms, OOP, OS, DBMS, and Software Engineering.",
        "⚡ Regular practice on coding platforms like LeetCode, HackerRank, and CodeChef.",
        "⚡ Ability to break down problems and design efficient logical solutions.",
      ],
      softwareSkills: [
        {
          skillName: "Data Structures & Algorithms",
          fontAwesomeClassname: "simple-icons:leetcode",
          style: {
            color: "#F79F1B",
          },
        },
        {
          skillName: "Object Oriented Programming",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#007396",
          },
        },
        {
          skillName: "Problem Solving",
          fontAwesomeClassname: "simple-icons:hackerrank",
          style: {
            color: "#2EC866",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/navaneeth02/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/navaneeth91",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/Navaneeth0204",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/navaneeth91",
    },
  ],
};

const degrees = {
  degrees: [
     {
      title: "Vardhaman College of Engineering, Shamshabad",
      subtitle: "B.Tech in Computer Science and Engineering (JNTUH)",
      logo_path: "vardhaman_logo.png", // add this image to your assets
      alt_name: "Vardhaman College of Engineering",
      duration: "2022 - 2026",
      descriptions: [
        "⚡ Pursuing B.Tech in Computer Science and Engineering under JNTUH with a CGPA of 8.7.",
        "⚡ Studied core subjects including Data Structures & Algorithms, Operating Systems, OOP, DBMS, and Software Engineering.",
        "⚡ Actively involved in academic projects and coding competitions.",
      ],
      website_link: "https://www.vardhaman.org/",
    },
    {
      title: "Telangana Model School & Junior College, Korutla",
      subtitle: "Intermediate (MPC), TGBIE",
      logo_path: "tms_junior_logo.png",
      alt_name: "Telangana Model School & Junior College",
      duration: "2020 - 2022",
      descriptions: [
        "⚡ Completed Intermediate in MPC with a CGPA of 9.0.",
        "⚡ Built a strong mathematical and analytical foundation.",
      ],
      website_link: "https://schooledu.telangana.gov.in/",
    },
    {
      title: "Telangana Model School, Korutla",
      subtitle: "Tenth Class, BSET",
      logo_path: "tms_school_logo.png",
      alt_name: "Telangana Model School",
      duration: "2020",
      descriptions: [
        "⚡ Completed 10th standard with a CGPA of 9.8.",
      ],
      website_link: "https://schooledu.telangana.gov.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Oracle Cloud Infrastructure 2025 Certified Generative AI Professional",
      subtitle: "- Oracle University",
      logo_path: "oracle_logo.png",
      certificate_link: "#",
      alt_name: "Oracle",
      color_code: "#F8000099",
    },
    {
      title: "Smart Coder Certification",
      subtitle: "- Smart Interviews (Global Rank: 762/42248, Diamond Certified)",
      logo_path: "smart_interviews_logo.png",
      certificate_link: "#",
      alt_name: "Smart Interviews",
      color_code: "#2A73CC99",
    },
    {
      title: "AWS Academy Graduate - Cloud Foundations",
      subtitle: "- AWS Academy",
      logo_path: "aws_logo.png",
      certificate_link: "#",
      alt_name: "AWS Academy",
      color_code: "#FF990099",
    },
    {
      title: "Front End Web Developer Certification",
      subtitle: "- Infosys Springboard",
      logo_path: "infosys_logo.png",
      certificate_link: "#",
      alt_name: "Infosys Springboard",
      color_code: "#2A73CC",
    },
    {
      title: "Programming in Java",
      subtitle: "- NPTEL, Swayam",
      logo_path: "nptel_logo.png",
      certificate_link: "#",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Data Structures and Algorithms using Java",
      subtitle: "- NPTEL, Swayam",
      logo_path: "nptel_logo.png",
      certificate_link: "#",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work & Internship",
  description:
    "I'm a Computer Science undergraduate who has worked on academic projects like an AI-powered Smart Recipe Generator and an e-learning platform, and completed internships in Salesforce development and AWS Cloud Computing.",
  header_image_path: "experience.svg",
  sections: [
   
    {
     title: "Internships",
      experiences: [
        {
          title: "Salesforce Developer Intern (Agentblazer Champion Program)",
          company: "SmartBridge (in collaboration with AICTE)",
          company_url: "https://www.smartinternz.com/",
          logo_path: "salesforce_logo.png",
          duration: "May 2025 - July 2025",
          location: "Online",
          description:
            "Completed an 8-week virtual internship covering Salesforce fundamentals including Organizational Setup, Data Management, Security Management, Apex, Process Automation, and Lightning Web Components. Earned the title of Agentblazer Champion through hands-on projects and superbadges.",
          color: "#00A1E0",
        },
        {
          title: "AWS Cloud Computing Intern",
          company: "NIELIT Virtual Academy, Hyderabad",
          company_url: "https://www.nielit.gov.in/",
          logo_path: "nielit.png",
          duration: "Aug 2024 - Oct 2024",
          location: "Online",
          description:
            "Gained hands-on experience with AWS services and cloud fundamentals. Configured and launched EC2 instances for scalable application hosting and developed skills in cloud infrastructure management and deployment.",
          color: "#FF9900",
        },
      ],
    },
   
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "ai-powered-smart-recipe-generator",
      name: "AI-Powered Smart Recipe Generator: A Machine Learning Approach",
      createdAt: "2025-01-01T00:00:00Z", // approximate; adjust if you know exact date
      description:
        "Paper presented at the International Conference on Computer Science and Communication Engineering (ICCSCE-2025).",
      url: "https://www.atlantis-press.com/proceedings/iccsce-25/126017458", // add link if you get a proceedings/DOI URL
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "navaneeth_profile.png", // add your image asset
    description:
      "I am available on email and social media. Feel free to reach out for opportunities, collaborations, or tech discussions related to Web Development, Java, React, Cloud, and DSA.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I plan to share my learning journey, project write-ups, and technical notes here.",
    link: "#", // add your blog link when you have one
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Hyderabad, Telangana, India",
    locality: "Hyderabad",
    country: "India",
    region: "Telangana",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/s8BLDW9g2gDudQmT7",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+91-7288928535",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
